/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        // All pages
        'common': {
            init: function () {
                // Enable mobile menu.
                var isFeatured = function (e) {
                    return e.parent().hasClass('_featured');
                }
                var setMargin = function (e, close) {
                    if (!isFeatured(e)) {
                        return;
                    }
                    var height = close ? 0 : e.parent().find('> .sub-menu').height();

                    const li = $('.slicknav_nav > li:not(._featured)').first();
                    li.css('margin-top', height - 6);
                }
                $('ul.nav').slicknav({
                    closeOnClick: true,
                    'closedSymbol': '<i class="fa fa-chevron-down" aria-hidden="true"></i>',
                    'openedSymbol': '<i class="fa fa-chevron-up" aria-hidden="true"></i>',
                    appendTo: 'header.banner',
                    duration: 0,
                    beforeOpen: function (e) {
                        if (!isFeatured(e)) {
                            return;
                        }

                        // Close any other featured menus.
                        $('.slicknav_nav li._featured.slicknav_open > a').each(function () {
                            if (e[0] !== this) {
                                $(this).trigger('click');
                            }
                        });
                    },
                    afterOpen: function (e) {
                        setMargin(e, false);
                    },
                    afterClose: function (e) {
                        setMargin(e, true);
                    }
                });

                // Show hidden sticky footer after some scrolling.
                var previousScrollTop = $(window).scrollTop();
                var totalScroll = 0;
                $(window).on('scroll', function (e) {
                    var stickyBanner = $('._sticky-banner');
                    if (stickyBanner.length) {
                        totalScroll += Math.abs($(window).scrollTop() - previousScrollTop);
                        previousScrollTop = $(window).scrollTop();
                        if (totalScroll > 500 && !stickyBanner.hasClass('_closed')) {
                            stickyBanner.removeClass('_hidden');
                        }
                    }
                });

                // Show search bar on mobile.
                $('header.banner ._search ._mobile-icon').on('click', function (e) {
                    var search = $(this).closest('._search');
                    search.toggleClass('_open');
                    search.find('.search-field').focus();
                });

                // Show/hide footer menus on mobile.
                $('.footer .widget_nav_menu h3').on('click', function (e) {
                    if ($(window).width() >= 768) {
                        return;
                    }

                    var parent = $(this).closest('.widget_nav_menu');
                    parent.find('.menu-footer-container').slideToggle();
                    parent.toggleClass('_open');
                });
            },
            finalize: function () {
                // JavaScript to be fired on all pages, after page specific JS is fired
            }
        },
        // Home page
        'home': {
            init: function () {
                // JavaScript to be fired on the home page
            },
            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS
            }
        },
        // About us page, note the change from about-us to about_us.
        'about_us': {
            init: function () {
                // JavaScript to be fired on the about us page
            }
        }
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function (func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function () {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');

            // Open header submenus
            $('.banner>.slicknav_menu>.slicknav_nav>li').each(function () {
                if (!$(this).hasClass('_featured') && $(this).hasClass('slicknav_parent')) {
                    $(this).find('>a').first().click();
                }
            });

            // Open first footer submenu
            $('#footer .widget_nav_menu').first().addClass('_open');

            // More info blocks
            $('.more-info-block ._footer').click(function () {
                var $footer = $(this);
                var $block = $footer.parent();
                if ($block.attr('data-is-open') === "0") {
                    $('._content_more', $block).stop().slideDown(300);
                    $block.attr('data-is-open', '1');
                    $('i', $footer).removeClass('fa-chevron-down').addClass('fa-chevron-up');
                    $('span', $footer).text('LESS INFO');

                } else {
                    $('._content_more', $block).stop().slideUp(300);
                    $block.attr('data-is-open', '0');
                    $('i', $footer).removeClass('fa-chevron-up').addClass('fa-chevron-down');
                    $('span', $footer).text('MORE INFO');
                }
            });

            if ($('#back-to-top').length) {
                var scrollTrigger = 1500;

                var backToTop = function () {
                    var scrollTop = $(window).scrollTop();
                    if (scrollTop > scrollTrigger) {
                        $('#back-to-top').addClass('show');
                    } else {
                        $('#back-to-top').removeClass('show');
                    }
                };
                backToTop();

                $(window).on('scroll', function () {
                    backToTop();
                });

                $('#back-to-top').on('click', function (e) {
                    e.preventDefault();
                    $('html,body').animate({scrollTop: 0}, 700);
                });
            }
        }
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
